exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".additional-adjustments.edit-student-adjustment .collapsible-trigger{margin-bottom:.95rem}.additional-adjustments.edit-student-adjustment .collapsible-trigger svg{position:relative;top:2px}.additional-adjustments.edit-student-adjustment p{margin:0}.additional-adjustments.edit-student-adjustment p .post-content{margin:0}.student-adjustment-form .description-alert{color:var(--color--meta);margin-bottom:.55rem}.student-adjustment-form .description-alert span.icon{position:relative;top:2px}.student-adjustment-form .description-alert span.icon .icon-standard{stroke:var(--color--meta)}", ""]);

// exports
